// extracted by mini-css-extract-plugin
export var infoItem = "_sb-2";
export var title = "_sb-0";
export var value = "_sb-1";